import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState } from "react";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Header_Home from "../Component/Header_Home";
import Header from "../Component/Header";
import "../../App.css";
import "react-datepicker/dist/react-datepicker.css";
import { TextField, Grid, InputLabel, TableFooter } from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import "../PaymentInquiry/paymentInquiry-styles.css";
import {
  searchRegisterHistoryAPI
} from "./RegisterHistoryService/registerHistoryService";
import Skeleton from "react-loading-skeleton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { TablePagination } from "@material-ui/core";
import "moment/locale/th";
import { MuiPickersUtilsProvider } from "material-ui-pickers";
import { DatePicker } from "material-ui-pickers";
import OverwriteMomentBE from "../../util/OverwriteMomentBE";
import moment from "moment";
import { IconButton, InputAdornment } from "@material-ui/core";
import AlarmIcon from "@material-ui/icons/CalendarToday";
import CircularProgress from "@mui/material/CircularProgress";
import { CustomInputText } from "../Component/CustomInputText";
import { CSVLink } from "react-csv";
import { Select, OutlinedInput, MenuItem } from "@mui/material";

const SendOTPHistory = () => {
  const theme = createTheme({
    components: {
      MuiTableHead: {
        styleOverrides: {
          root: {
            // backgroundColor: "#FFA500",
          },
        },
      },
    },
  });

  useEffect((date) => {
    // getConvertFormat(date)
  }, []);

  const style = {
    py: 0,
    width: "100%",
    maxWidth: 360,
    borderRadius: 2,
    border: "1px solid",
    borderColor: "divider",
    backgroundColor: "background.paper",
  };

  const [policyNo, setPolicyNo] = useState("");
  const [rowMangeOtp, setRowMangeOtp] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [LoadingContent, setLoadingContent] = useState(false);
  const [spinner, setSpinner] = useState();
  const [otpDateStart, setOtpDateStart] = useState(null);
  const [otpDateEnd, setOtpDateEnd] = useState(null);
  const [reqDateStart, setReqDateStart] = useState(null);
  const [reqDateEnd, setReqDateEnd] = useState(null);
  const [insuredName, setInsuredName] = useState("");
  const [mobile,setMobile] = useState("");

  
  const clear = () => {
    setInsuredName('');
    setMobile('');
    setReqDateStart('');     
    setReqDateEnd('');
    setRowMangeOtp([]);
    // searchRegisterHistory();
  };
  

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const searchRegisterHistory = async () => {
    setLoadingContent(true);
    const payload = {
      regisDateStart: (formatDate3(reqDateStart) ?? "").trim(),
      regisDateEnd: (formatDate3(reqDateEnd) ?? "").trim(),
      mobile: (mobile ?? "").trim(),
      insuredName: (insuredName ?? "").trim(),
    };
    

    const result = await searchRegisterHistoryAPI(payload);
    // console.log(result);
    setTimeout(() => {
      setPage(0);
      setRowMangeOtp(result.data);
      setLoadingContent(false);
    }, 1000);
  };


  const handleChangeMobile = (e) => {
    setMobile(e.target.value);
  };


  const handleChangeFullName = (e) => {
    setInsuredName(e.target.value);
  };

  const handleOtpDateStart = (date) => {
    setOtpDateStart(date);
  };

  const handleOtpDateEnd = (date) => {
    setOtpDateEnd(date);
  };

  const handleReqDateStart = (date) => {
    setReqDateStart(date);
  };

  const handleReqDateEnd = (date) => {
    setReqDateEnd(date);
  };

  const formatDate3 = (date) => {
    if (!date) return "";
  
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
  
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    searchRegisterHistory();
  }, []);

  

  const handleSearchClick = () => {
    searchRegisterHistory();
  };

  const generateCsvData = (data) => {
    let data_csv = [];

    data.forEach((item, index) => {
      const data_row = {
        seq: index + 1, 
        act_code_timestamp: item.act_code_timestamp
          ? moment(item.act_code_timestamp).format("DD/MM/YYYY HH:mm:ss")
          : "-",
        mobile: `=""${item.mobile}""`,
        full_name: item.full_name,
        
      };
      data_csv.push(data_row);
    });

    return data_csv;
  };

  const data_csv = generateCsvData(rowMangeOtp);

  const headers = [
    { label: "วันที่ลงทะเบียน", key: "act_code_timestamp" },
    { label: "เบอร์โทรศัพท์", key: "mobile" },
    { label: "ชิ่อ-นามสกุล ผู้เอาประกัน", key: "full_name" },
    
  ];

  const generateFilename = () => {
    const currentDate = moment().format("YYYYMMDDHHmm");
    return `REGISTER_HISTORY_${currentDate}.csv`;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const d = new Date(dateString);
    const pad = (n) => (n < 10 ? "0" + n : n);
    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
  };

  return (
    <div>
      <Header_Home />
      <Header title="ประวัติการลงทะเบียน" />
      {spinner && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 9999,
          }}
        >
          <CircularProgress
            sx={{
              animationDuration: "550ms",
            }}
            color="inherit"
          />
        </div>
      )}
      <div className="table-page-container footer-space">
        <div className="rounded-border bg-white p-2">
          <br />
          <div id="export" className="margin-l-auto text-align-right">
              <CSVLink
                data={data_csv}
                headers={headers}
                filename={generateFilename()}
                style={{ fontSize: 18 }}
                className="btn-fill-export  p-2 bold"
              >
                Export File
              </CSVLink>
            </div>

            <br />
          <Grid
            container
            spacing={2}
            style={{ paddingInline: "32px", marginBottom: "15px" }}
          >
            {/* แถวที่ 1 */}
            <Grid item xs={12} md={6}>
              <CustomInputText
                id="input-policyNo"
                label="ชื่อ-นามสกุล ผู้เอาประกัน"
                placeholder="ชื่อ-นามสกุล ผอป."
                value={insuredName}
                onChange={handleChangeFullName}
                InputProps={{ style: { borderRadius: "16px", height: "42px" } }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <CustomInputText
                id="input-fullname"
                label="เบอร์โทรศัพท์"
                placeholder="เบอร์โทรศัพท์"
                value={mobile}
                onChange={handleChangeMobile}
                InputProps={{ style: { borderRadius: "16px", height: "42px" } }}
              />
            </Grid>
            {/* แถวที่ 2 */}
            <Grid item xs={12} md={3}>
              <label htmlFor="from-date" style={{ fontWeight: "bold" }}>
              วันที่ลงทะเบียน
              </label>
              <MuiPickersUtilsProvider
                utils={OverwriteMomentBE}
                locale="th"
                moment={moment}
              >
                <DatePicker
                  pickerHeaderFormat="DD/MM/YYYY"
                  format="DD/MM/YYYY"
                  placeholder="วันที่เริ่มต้น"
                  defaultValue={""}
                  value={reqDateStart || null}
                  onChange={handleReqDateStart}
                  fullWidth
                  autoOk={true}
                  InputProps={{
                    style: {
                      borderRadius: "16px",
                      height: "42px",
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton>
                          <AlarmIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  variant="outlined"
                  style={{ borderRadius: "16px", height: "42px" }}
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={12} md={3}>
              <label htmlFor="from-date" style={{ fontWeight: "bold" }}>
                &nbsp;
              </label>
              <MuiPickersUtilsProvider
                utils={OverwriteMomentBE}
                locale="th"
                moment={moment}
              >
                <DatePicker
                  pickerHeaderFormat="DD/MM/YYYY"
                  format="DD/MM/YYYY"
                  placeholder="วันที่สิ้นสุด"
                  defaultValue={""}
                  value={reqDateEnd || null}
                  onChange={handleReqDateEnd}
                  fullWidth
                  autoOk={true}
                  InputProps={{
                    style: {
                      borderRadius: "16px",
                      height: "42px",
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton>
                          <AlarmIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  variant="outlined"
                  style={{ borderRadius: "16px", height: "42px" }}
                />
              </MuiPickersUtilsProvider>
            </Grid>
          </Grid>
          <br />
          <div className="App">
            <section className="filter-action-section">
              <button
                style={{ fontSize: 18 }}
                onClick={handleSearchClick}
                className="btn-fill-orange  p-2 bold"
              >
                ค้นหา
              </button>
              <button onClick={clear} className="btn-fill-gray p-2 bold ml-2" style={{ marginLeft: '12px' }}>
                ล้าง
              </button>
            </section>
            <br />

            {LoadingContent ? (
              <div className="p-4">
                <div className="p-2">
                  <Skeleton className="h-70px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                </div>
              </div>
            ) : (
              <ThemeProvider theme={theme}>
                <TableContainer style={{ height: "auto" }} component={Paper}>
                  <Table aria-label="collapsible table">
                    <TableHead>
                      <TableRow style={{ backgroundColor: "#e7e7e786" }}>
                        {/* <TableCell
                          className="font-new"
                          align="center"
                          style={{ width: 300, minWidth: 8 }}
                        >
                          Request Date
                        </TableCell> */}
                        <TableCell
                          className="font-new"
                          align="center"
                          style={{ width: 300, minWidth: 8 }}
                        >
                          วันที่ลงทะเบียน
                        </TableCell>
                        <TableCell
                          className="font-new"
                          align="center"
                          style={{ width: 200, minWidth: 8 }}
                        >
                          เบอร์โทรศัพท์
                        </TableCell>
                        <TableCell
                          className="font-new"
                          align="center"
                          style={{ width: 200, minWidth: 70 }}
                        >
                          ชิ่อ-นามสกุล ผู้เอาประกัน
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rowMangeOtp.length > 0 ? (
                        rowMangeOtp
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          .map((item, idx) => {
                            const seq = idx + 1 + page * rowsPerPage;
                            return (
                              <TableRow>
                                {/* <TableCell
                                  className="font-new"
                                  align="center"
                                  style={{ width: 100, minWidth: 8 }}
                                >
                                  {formatDate(item.createDate)}
                                </TableCell> */}
                                <TableCell
                                  className="font-new"
                                  align="center"
                                  style={{ width: 300, minWidth: 8 }}
                                >
                                  {formatDate(item.act_code_timestamp)}
                                </TableCell>
                                <TableCell
                                  className="font-new"
                                  align="center"
                                  style={{ width: 200, minWidth: 8 }}
                                >
                                  {item.mobile}
                                </TableCell>
                                <TableCell
                                  className="font-new"
                                  align="center"
                                  style={{ width: 200, minWidth: 70 }}
                                >
                                  {item.full_name}
                                </TableCell>
                              </TableRow>
                            );
                          })
                      ) : (
                        <TableRow>
                          <TableCell align="center" colSpan={10}>
                            <span className="font-new">ไม่พบข้อมูล</span>
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={rowMangeOtp.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </TableContainer>
              </ThemeProvider>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SendOTPHistory;
